<mwc-tabbar [structure]="tabBarStructure"
  [userInformations]="userInformations"
  activeItemId="financialSpace"
  (routingRequest)="changeRoute($event)">
</mwc-tabbar>
